"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Send, Loader, CircleCheck } from "lucide-react";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 rounded-xl border border-border bg-card p-8 text-center shadow-lg">
        <CircleCheck className="size-12 text-emerald-500" />
        <h3 className="font-default text-2xl font-semibold text-foreground">
          Inquiry Received
        </h3>
        <p className="text-muted-foreground">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Submit Another Inquiry
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6 rounded-xl border border-border bg-card p-6 shadow-xl md:p-8">
      <div className="grid gap-6 md:grid-cols-2">
        <FormField control={control} name="projectName" rules={{
        required: "Project Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Project Name</FormLabel>
              <FormControl>
                <Input placeholder="Enter project name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="organization" rules={{
        required: "Organization is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Organization</FormLabel>
              <FormControl>
                <Input placeholder="Your company or agency" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <FormField control={control} name="location" rules={{
        required: "Location of Interest is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Location of Interest</FormLabel>
              <FormControl>
                <Input placeholder="Coordinates or region" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="resolution" rules={{
        required: "Required Resolution is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Required Resolution</FormLabel>
              <FormControl>
                <Input placeholder="e.g., 30cm, 50cm, 1m" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="timeline" rules={{
      required: "Timeline is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Timeline</FormLabel>
            <FormControl>
              <Input placeholder="When do you need the data?" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="notes" render={({
      field
    }) => <FormItem>
            <FormLabel>Additional Notes</FormLabel>
            <FormControl>
              <Textarea placeholder="Any specific requirements or context..." className="min-h-[120px]" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-emerald-500 text-white hover:bg-emerald-600 focus-visible:ring-emerald-500/50 dark:bg-emerald-600 dark:hover:bg-emerald-700" size="lg">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Processing Inquiry...
          </> : <>
            Submit Inquiry
            <Send className="ml-2 size-5" />
          </>}
      </Button>
    </Form>;
}
export default function InquiryCallToAction() {
  return;
}